import { auth, callFunction } from "./firebase.js";
import { createAuthGateway } from "./auth/gateway.js";

/** 게이트웨이는 앱에 한 벌만 있다. 화면은 여기서 가져다 쓴다. */
export const gw = createAuthGateway({ auth, callFunction });

/**
 * 구글 웹 클라이언트 ID — 공개 식별자다. 동의 화면에 그대로 노출되는 값이고,
 * functions/.env.sowhat-run 에도 같은 값이 커밋돼 있다.
 * (짝이 되는 **시크릿**은 Secret Manager 에만 있다. 코드 교환은 서버가 한다)
 */
export const GOOGLE_CLIENT_ID =
  "627567526831-ibim1fov3q6ph7cc92662e4l32vgvc7l.apps.googleusercontent.com";

/** 제공자마다 credential() 이 요구하는 것이 다르다. 화면이 그걸 알 필요는 없다. */
export function upgradeWith(providerId, form) {
  if (providerId === "google") return gw.upgrade("google", { clientId: GOOGLE_CLIENT_ID });
  return gw.upgrade(providerId, form);
}
